import type { FeatureCollection } from 'geojson'
import { Layer, Source } from 'react-map-gl'
import { ParcelData } from '~/models'

export default function SimpleParcelsLayer({
  parcels,
  style = 'light',
}: {
  parcels: ParcelData[]
  style?: 'light' | 'dark'
}) {
  const feature: FeatureCollection = {
    type: 'FeatureCollection',
    features: parcels.map((parcel) => ({
      type: 'Feature',
      properties: {},
      geometry: parcel.geometry,
    })),
  }

  return (
    <Source id="parcel-data" type="geojson" data={feature}>
      <Layer
        id="parcel"
        type="line"
        paint={
          style === 'light'
            ? {
                'line-color': '#000000',
                'line-opacity': 0.25,
                'line-width': 3,
              }
            : {
                'line-color': '#ffffff',
                'line-opacity': 0.75,
                'line-width': 3,
              }
        }
      />
      <Layer
        id="parcel-fill"
        type="fill"
        paint={
          style === 'light'
            ? {
                'fill-color': '#000000',
                'fill-opacity': 0.15,
              }
            : {
                'fill-color': '#ffffff',
                'fill-opacity': 0.25,
              }
        }
      />
    </Source>
  )
}
